import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

const InsuranceAddress = ({data, folder}) => {
    const [locationAddress, setLocationAddress] = useState(null)
    const activeCase = useSelector(state => state.case.activeCase)

    useEffect(() => {
        let address = `${data.insurance_carrier?.contact_information?.address_1 ? data.insurance_carrier.contact_information.address_1 : ''}, 
                    ${data.insurance_carrier?.contact_information?.city ? data.insurance_carrier.contact_information.city : ''}, 
                    ${data.insurance_carrier?.contact_information?.state ? data.insurance_carrier.contact_information.state : ''} 
                    ${data.insurance_carrier?.contact_information?.zip ? data.insurance_carrier.contact_information.zip : ''}`


        if (activeCase) {
            let changed;
            if (folder !== 'worker_comp') {
                changed = activeCase[folder].find(item => item.id == data.id)
            } else {
                changed = activeCase[folder]
            }
            
            
            if (changed && changed.location) {
                address = `
                    ${changed.location?.contact_information?.address_1 ? changed.location.contact_information.address_1 : ''}, 
                    ${changed.location?.contact_information?.city ? changed.location.contact_information.city : ''}, 
                    ${changed.location?.contact_information?.state ? changed.location.contact_information.state : ''} 
                    ${changed.location?.contact_information?.zip ? changed.location.contact_information.zip : ''}`
            } 

            setLocationAddress(address)
        }
        
    }, [activeCase, data])
    
    return <>{locationAddress}</>
}

export default InsuranceAddress